import { SimplePlayer, I18N } from 'xgplayer';
// import Player from 'xgplayer';

// 引入es目录下的插件
import Start from 'xgplayer/es/plugins/start'
import PC from 'xgplayer/es/plugins/pc'
import Mobile from 'xgplayer/es/plugins/mobile'
import Progress from 'xgplayer/es/plugins/progress'
import Time from 'xgplayer/es/plugins/time'
import Play from 'xgplayer/es/plugins/play'
import Error from 'xgplayer/es/plugins/error'
import Fullscreen from 'xgplayer/es/plugins/fullscreen' 
import Volume from 'xgplayer/es/plugins/volume' 

import 'xgplayer/dist/index.min.css';

import ZH from 'xgplayer/es/lang/zh-cn'

// 启用中文
I18N.use(ZH)

// 生成播放器实例
export const genPlayerInstance = (config = {}) => {
  const ins = new SimplePlayer({
    height: '100%',
    width: '100%',
    plugins: [Start, PC, Mobile, Progress, Play, Time, Error, Fullscreen, Volume], // 传入需要组装的插件
    Mobile: {
      gestureY: false
    },
    ...config,
  });
  return ins 
}
